import React from 'react'
import './keyar-layout.scss'

const Interpretation = ({interpretationData, difference, interpretationDisable}) => {
   //console.log(interpretationData)
    
  return (
    <>
    { interpretationDisable ?
        (
            <div className='interpretation-box'>
                <div className='interpretation-block'>
                    <div className='interpretation-data'>
                        <div className="interpretation-header">FHR1 Interpretation</div>
                        { difference != '' && difference >= 600000 ? 
                            <div className='fhr1-block'>
                                <div className='nst-header nst-title'>
                                    <div className='fhr_rows'>
                                        <p className='fhr-keys'>Signal Loss</p>
                                        <p className='colon'>:</p>
                                        <p className='fhr-value'>{`${interpretationData.interpretation_for_fhr1?.signal_loss}%` || '--'}</p>
                                    </div>
                                </div>
                                <div className='nst-header nst-title'>
                                    <div className='fhr_rows'>
                                        <p className='fhr-keys'>Baseline</p>
                                        <p className='colon'>:</p>
                                        <p className='fhr-value'>{`${interpretationData.interpretation_for_fhr1?.baseline} BPM` || '--'}</p>
                                    </div>
                                </div>
                                <div className='nst-header nst-title'>
                                    <div className='fhr_rows'>
                                        <p className='fhr-keys'>Heart Rate</p>
                                        <p className='colon'>:</p>
                                        <p className='fhr-value'>{interpretationData.interpretation_for_fhr1?.baseline_heart_rate || '--'}</p>
                                    </div>
                                </div> 
                                <div className='nst-header nst-title'>
                                    <div className='fhr_rows'>
                                        <p className='fhr-keys'>Acceleration</p>
                                        <p className='colon'>:</p>
                                        {/* {console.log(interpretationData.interpretation_for_fhr1?.acceleration)} */}
                                        <p className='fhr-value'>{interpretationData.interpretation_for_fhr1?.acceleration ?? '--'}</p>
                                    </div>
                                </div>
                                
                                <div className='nst-header nst-title'>
                                    <div className='fhr_rows'>
                                        <p className='fhr-keys'>Deceleration</p>
                                        <p className='colon'>:</p>
                                        <p className='fhr-value'>{interpretationData.interpretation_for_fhr1?.deceleration ?? '--'}</p>
                                    </div>
                                </div> 

                                <div className='nst-header nst-title'>
                                    <div className='fhr_rows'>
                                        <p className='fhr-keys'>Early Deceleration</p>
                                        <p className='colon'>:</p>
                                        <p className='fhr-value'>{interpretationData.interpretation_for_fhr1?.early_deceleration ?? '--'}</p>
                                    </div>
                                </div> 

                                <div className='nst-header nst-title'>
                                    <div className='fhr_rows'>
                                        <p className='fhr-keys'> Late Deceleration</p>
                                        <p className='colon'>:</p>
                                        <p className='fhr-value'>{interpretationData.interpretation_for_fhr1?.late_deceleration || '--'}</p>
                                    </div>
                                </div> 

                                <div className='nst-header nst-title'>
                                    <div className='fhr_rows'>
                                        <p className='fhr-keys'>Variable Deceleration</p>
                                        <p className='colon'>:</p>
                                        <p className='fhr-value'>{interpretationData.interpretation_for_fhr1?.variable_deceleration || '--'}</p>
                                    </div>
                                </div>

                                <div className='nst-header nst-title'>
                                    <div className='fhr_rows'>
                                        <p className='fhr-keys'>Prolonged Deceleration</p>
                                        <p className='colon'>:</p>
                                        <p className='fhr-value'>
                                        {interpretationData.interpretation_for_fhr1?.prolongedDeceleration ?? '--'}
                                        </p>
                                    </div>
                                </div>

                                <div className='nst-header nst-title'>
                                    <div className='fhr_rows'>
                                        <p className='fhr-keys'>Contractions</p>
                                        <p className='colon'>:</p>
                                        <p className='fhr-value'>{interpretationData.interpretation_for_fhr1?.contrations ?? '--'}</p>
                                    </div>
                                </div>

                                <div className='nst-header nst-title'>
                                    <div className='fhr_rows'>
                                        <p className='fhr-keys'>Average Duration</p>
                                        <p className='colon'>:</p>
                                        <p className='fhr-value'>{`${interpretationData.interpretation_for_fhr1?.average_duration} seconds` || '--'}</p>
                                    </div>
                                </div>

                                <div className='nst-header nst-title'>
                                    <div className='fhr_rows'>
                                        <p className='fhr-keys'>Long Term Variability</p>
                                        <p className='colon'>:</p>
                                        <p className='fhr-value'>{`${interpretationData.interpretation_for_fhr1?.long_term_variablity} BPM` || '--'}</p>
                                    </div>
                                </div>

                                <div className='nst-header nst-title'>
                                    <div className='fhr_rows'>
                                        <p className='fhr-keys'>Short Term Variability</p>
                                        <p className='colon'>:</p>
                                        <p className='fhr-value'>{`${interpretationData.interpretation_for_fhr1?.short_term_variablity} ms` || '--'}</p>
                                    </div>
                                </div>

                                
                               
                                <div className='nst-header nst-title'>
                                    <div className='fhr_rows'>
                                        <p className='fhr-keys'>Trace Category</p>
                                        <p className='colon'>:</p>
                                        <p className='fhr-value'>{interpretationData.interpretation_for_fhr1?.trace_category || '--'}</p>
                                    </div>
                                </div> 

                            </div>
                        :
                        <div style={{height: 250}}>
                            <div className='nst-header nst-title'>
                                <div className='fhr_rows'>
                                    <p className='fhr-keys'>Total Monitoring Time</p>
                                    <p className='colon'>:</p>
                                    <p className='fhr-value'>{Math.round(difference/60000)} min</p>
                                </div>
                            </div>
                        <div>
                            <p style={{textAlign: 'center', fontSize: 12, padding: '5px 5px'}}>
                                No data available before 10 minutes of monitoring
                            </p>
                        </div>
                        </div>
                        }
                    </div>
                </div>

                <div className='interpretation-block additional-notes-block'>
                    <div className="interpretation-header">
                        Additional Notes
                    </div>
                </div>
            </div>
        )
    :
        <div className='notes-box'>
            <div className="interpretation-header" >
                Additional Notes
            </div>
        </div>
    }
    </>
  )
}

export default Interpretation
